import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomValidators } from "ng2-validation";
import { ConfirmationService, MessageService } from "primeng/api";
import { TournamentsService } from "src/app/services/tournamnet.service";
import { LazyLoadEvent } from "primeng/api";

import { TokenStorageService } from "src/app/services/token-storage.service";
import { environment } from "src/environments/environment";
import * as XLSX from 'xlsx';
@Component({
  selector: "app-player-list",
  templateUrl: "./player-list.component.html",
  styleUrls: ["./player-list.component.scss"],
})
export class PlayerListComponent implements OnInit {
  categoryDelet: boolean = false;
  id;
  query;
  item;
  tournamentname;
  tournamentData;
  categoryList;
  playerDetails;
  playerRegister: Boolean = false;
  matchtypeName: any;
  count: any;
  categoryId: any;
  tournamentstartdate: any;
  tournamentenddate: any;
  thankwithdraw: boolean = false;
  countdown: number = 10;
  countdownInProgress: boolean = false;
  tournamentStartdate: any;
  tournamentEnddate: any;
  loggedInAcademy: any;
  authorizedToDelete: boolean;
  public loggedInAcademyId;
  public tournamentAcademyId;
  isAcademy: boolean;
  isLoginUser: boolean;
  loginUser: any;
  loginUserId: any;
  loggedInUserId: any;
  isUser: boolean;
  showPmdtaNo: boolean;
  userId:any;
  showPuneTournaments: boolean;
  selectedTournamentCityName: string;
  constructor(
    private formBuilder: FormBuilder,

    private route: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private renderer: Renderer2,
    private tournamentsService: TournamentsService
  ) { }
  ngOnInit(): void {
    this.renderer.addClass(document.body, "RegisteredMobile");
    this.id = this.route.snapshot.paramMap.get("id");
    this.getTournamentsDetails();
    this.loggedInAcademy = this.tokenStorage.getUser();
    let roleName = this.loggedInAcademy.userdata.rolename;
    if (roleName == "academy") {
      this.authorizedToDelete = true;
      this.loggedInAcademyId = this.loggedInAcademy.userdata.academyId;
      this.isAcademy = true;
    } else {
      this.authorizedToDelete = false;
      this.isAcademy = false;
    }

    this.loggedInUserId = this.loggedInAcademy.userdata['id'];
  }

  getTournamentsDetails() {
    this.tournamentsService.getTournamentsDetails(this.id).subscribe((res) => {
      this.tournamentname = res.name;
      this.tournamentStartdate = res.startdate;
      this.tournamentEnddate = res.enddate;
      this.tournamentAcademyId = res.academyId;
      this.categoryList = res.tournamentCategories;
      this.tournamentData = res;
      this.categoryList.forEach((dt) => {
        if (this.tournamentData.cityname == 'Pune') {
          
          this.showPuneTournaments = true;
        } else {
          this.showPuneTournaments = false;
        }
        let query =
          "?matchTypeId=" +
          dt.matchtypeData[0]["_id"] +
          "&ageGroupId=" +
          dt.ageGroupData[0]["_id"];
        this.tournamentsService
          .getListOfPlayers(this.id, query)
          .subscribe((data) => {
            dt.playerListData = data.data.items;
            if (dt.playerListData.length < 1) {
              this.playerRegister = false;
            } else {
              this.playerRegister = true;
            }

            
          });
      });

    });
    (err) => {
      console.log(err);
    };
  }

  deleteCategoryDialog(matchtypeName, count, id) {
    this.categoryId = id;
    this.matchtypeName = matchtypeName;
    this.count = count;
    this.categoryDelet = true;
  }
  deleteCategoryFunction() {
    let data = {
      disable: true,
    };

    this.tournamentsService
      .deleteCategory(this.categoryId, data)
      .subscribe((dt) => {
        this.thankwithdraw = true;
        this.countdownInProgress = true;
        const interval = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            clearInterval(interval);
            this.countdownInProgress = false;
            window.location.reload();
          }
        }, 1000);
        this.categoryId = null;
        this.matchtypeName = null;
        this.count = null;
      });
  }
  startCountdown(): void {
    this.countdownInProgress = true;
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.countdownInProgress = false;
      }
    }, 1000);
  }
  resetCountdown(): void {
    this.countdown = 10;
    this.countdownInProgress = false;
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, "RegisteredMobile");
  }

  exportExcel(): void {
    const data = [];
    const sheetName = 'TournamentData';
    const academyTournamentdata = [];
    academyTournamentdata.push(this.tournamentData);
    let totalLength = 0;
    let academyCounter = 1;
    let tournamentNameCounter = 1;
    for (const tournament of academyTournamentdata) {
      let tournamentTotal = 0;
      for (const category of tournament.tournamentCategories || []) {
        totalLength += category.playerListData.length;
        const categoryName = (category.matchtypeData[0] && category.matchtypeData[0].name) || 'N/A';
        const ageGroupName = (category.ageGroupData[0] && category.ageGroupData[0].name) || 'N/A';
        let categoryCounter = 1;
        if (!category.playerListData || category.playerListData.length === 0) {
          data.push([
            academyCounter === 1 ? tournament.academyName : '',
            tournamentNameCounter === 1 ? tournament.name : '',
            categoryCounter === 1 ? `${categoryName} | AgeGroup: ${ageGroupName}` : '',
            '0',
            '',
            '',
          ]);
          academyCounter++;
          tournamentNameCounter++;
          categoryCounter++;
          // tournamentTotal++;
        }
        let playerListDataLengthCounter = 1;
        for (const playerEntry of category.playerListData || []) {
          const entryFee = playerEntry.entryFee || 'N/A';
          const totalCount = category.playerListData.length;
          const playerName = playerEntry.playerDetails[0]?.fullName || 'N/A';
          const contactNo = playerEntry.playerDetails[0]?.mobileNumber || 'N/A';
          const pmdtaNumber = playerEntry.pmdtaNumber;
          const doublePlayerPmdtaNumber = playerEntry.doublePlayerPmdtaNumber;
          // const doublePlayerPmdtaNumber = playerEntry.doublePlayerPmdtaNumber;
          if (playerEntry.doubleplayerDetails && playerEntry.doubleplayerDetails.length > 0) {
            const partnerDetails = playerEntry.doubleplayerDetails || [];
            for (const partner of partnerDetails) {
              const partnerName = partner.fullName || 'N/A';
              const partnerContact = partner.mobileNumber || 'N/A';
              data.push([
                academyCounter === 1 ? tournament.academyName : '',
                tournamentNameCounter === 1 ? tournament.name : '',
                categoryCounter === 1 ? `${categoryName} | AgeGroup: ${ageGroupName}` : '',
                playerListDataLengthCounter == 1 ? `${category.playerListData.length}` : '',
                `${playerName}/${partnerName}`,
                `${contactNo}/${partnerContact}`,
                `${pmdtaNumber}/${doublePlayerPmdtaNumber}`,
              ]);
              academyCounter++;
              tournamentNameCounter++;
              categoryCounter++;
              playerListDataLengthCounter++;
              tournamentTotal++;
            }
          } else {
            data.push([
              academyCounter === 1 ? tournament.academyName : '',
              tournamentNameCounter === 1 ? tournament.name : '',
              categoryCounter === 1 ? `${categoryName} | AgeGroup: ${ageGroupName}` : '',
              playerListDataLengthCounter == 1 ? `${category.playerListData.length}` : '',
              playerName,
              contactNo,
              pmdtaNumber,
              doublePlayerPmdtaNumber
              
            ]);
            academyCounter++;
            tournamentNameCounter++;
            categoryCounter++;
            playerListDataLengthCounter++;
            tournamentTotal++;
          }
        }
      }
      data[0].push(tournamentTotal);
    }
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([
      ['Name of the Academy', 'Name of the Tournament', 'Category Wise', 'Registrations in each category', 'Player Name', 'Contact No', 'PMDTA No', 'Registrations in the respective tournament'],
      ...data,
    ]);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, 'tournament_data.xlsx');
  }
}
